import React, { PureComponent } from "react";
import { Row, Col, Container } from "react-bootstrap";

import RegisterForm from "./RegisterForm";
import { BidsAgreements } from "storefront/features/shared";

export default class Register extends PureComponent {
  render() {
    return (
      <Container>
        <Row className="justify-content-center my-5">
          <Col className="m-5 text-center col-md-6 col-10">
            <h1>REGISTER</h1>
            <RegisterForm />
            <BidsAgreements
              termsAndConditionsLink="/pages/terms-and-conditions"
              privacyPolicy="/pages/privacy-policy"
            />
          </Col>
        </Row>
      </Container>
    );
  }
}
